import { inject, injectable } from 'inversify'
import {
  AddProductUseCaseInput,
  AddProductUseCaseOutput,
  IAddProductUseCase,
  IAppErrorFactory,
  ICompaniesService,
  IProductFactory,
} from '../../types'
import symbols from '../../symbols'
import { getValidUrl } from '../../utils'

@injectable()
export default class AddProductInteractor implements IAddProductUseCase {
  @inject(symbols.ICompaniesService) private companiesService: ICompaniesService

  @inject(symbols.IProductFactory) private productFactory: IProductFactory

  @inject(symbols.IAppErrorFactory) private errorFactory: IAppErrorFactory

  async handle(input: AddProductUseCaseInput): Promise<AddProductUseCaseOutput> {
    const output = this.getDefaultOutputData()
    try {
      // URL のプロトコル部分を調整
      input.product.url = getValidUrl(input.product.url)

      const base = await this.companiesService.addProduct(input)
      output.product = this.productFactory.create({ base })
    } catch (e) {
      output.error = this.errorFactory.create({
        originalInstance: e as Error,
        messageForUI: 'プロダクトの登録に失敗しました',
      })
    }

    return output
  }

  private getDefaultOutputData(): AddProductUseCaseOutput {
    return {
      product: null,
      error: null,
    }
  }
}
